import ArrowRightIcon from '../svg/ArrowRightIcon';

export default function RechargeItem({
  leftIcon,
  title,
  subTitle = '',
  onClick,
}) {
  return (
    <button
      onClick={onClick}
      className="w-full px-6 py-2 cursor-pointer border border-[#2A59C6] rounded-[10px] flex items-center justify-between"
    >
      <div className="w-10.5 h-10.5 bg-[#092F7B] rounded-full flex items-center justify-center">
        {leftIcon}
      </div>
      <div>
        <p className="text-sm text-[#414651] font-medium leading-[22px]">
          {title}{' '}
          <span className="text-[#535862] font-normal">{' ' + subTitle}</span>
        </p>
      </div>
      <ArrowRightIcon />
    </button>
  );
}
